import { Divider, Typography } from '@mui/material';
import { DashboardHeaderRoot } from '../styles';
import FlexBetween from '../../../components/flexbox/FlexBetween';
import FlexRowAlign from '../../../components/flexbox/FlexRowAlign';
import Docs from '../../../page-sections/docs';
import Roadmap from '../../../page-sections/roadmap';
import { ProcessingTask } from '../../../page-sections/ProcessingTask';
export default function DashboardHeader() {
  return <DashboardHeaderRoot position="sticky">
    <FlexBetween sx={{ px: 2 }}>
      <Typography variant='h5' sx={{ color: '#8aeb5d' }}>[codium]</Typography>
      <FlexRowAlign gap={1}>
        <ProcessingTask />
        <Divider orientation='vertical' sx={{ height: '10px' }} />
        <Roadmap />
        <Divider orientation='vertical' sx={{ height: '10px' }} />
        <Docs />
      </FlexRowAlign>
    </FlexBetween>
  </DashboardHeaderRoot>;
}